import React from "react";
import * as reactI18next from 'react-i18next';

const ReactTrans = reactI18next.Trans;

export const useTranslation = reactI18next.useTranslation;

export const Trans = ({
  children,
  ...props
}) => {
  return (
    <ReactTrans 
      tOptions={{'interpolation': {'escapeValue': false}}}
      {...props}
    >
      {children}
    </ReactTrans>
  )
};
